import { GetAllDto } from "../Shared/dto/get-all-dto";
import { ContactTypes } from "../Shared/enums/contact-types";
import { ApiUrls, BindQuery } from "./api-urls";
import { ApplicationService, HttpService } from "./application.service"

export const ContactService = {
    getContactsForModal: (getAllDto: GetAllDto) => {
        return ApplicationService.get<any>(BindQuery(ApiUrls.GET_CONTACTS_FOR_MODAL, getAllDto));
    },
    getContacts: (getAllDto: GetAllDto) => {
        return ApplicationService.get<any>(BindQuery(ApiUrls.GET_CONTACTS, getAllDto));
    },
    getById: (estimateId: any) => {
        return ApplicationService.get<any>(ApiUrls.GET_BY_ID_CONTACTS(estimateId));
    },
    saveData: (data: any) => {
        if (data.id) return ApplicationService.put(ApiUrls.CONTACTS_PUT(data.id), data)
        return ApplicationService.post<any>(ApiUrls.CONTACT_POST, data)
    },
    saveDataGetId: (data: any) => {
        if (data.id) return ApplicationService.put(ApiUrls.CONTACTS_PUT(data.id), data)
        return ApplicationService.post<any>(ApiUrls.CONTACT_GET_ID_POST, data)
    },
    getContactByType: (getAllDto: GetAllDto, contactType: ContactTypes) => {
        return ApplicationService.get<any>(`${ApiUrls.GET_CONTACTS_FOR_MODAL}?recordsPerPage=${getAllDto.recordsPerPage}` +
            `&pageNumber=${getAllDto.pageNumber}` +
            `&sortBy=${getAllDto.sortBy}` +
            `&sortOrder=${getAllDto.sortOrder}` +
            `&contactType=${contactType}` +
            (getAllDto.searchQuery ? `&searchQuery=${getAllDto.searchQuery}` : ``));
    }
}
